import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/sent-desktop.svg'


const _hoisted_1 = {
  class: "modal modal-lg fade",
  id: "modal-only-desktop",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = {
  class: "btn btn-primary mt-5 w-100",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Fechar"
}
const _hoisted_6 = {
  class: "btn-mobile btn btn-primary mt-3",
  type: "button",
  "data-bs-target": "#modal-only-desktop",
  "data-bs-toggle": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "message", {}, undefined, true),
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              src: _imports_0,
              alt: "menina sorrindo"
            }, null, -1)),
            _createElementVNode("button", _hoisted_5, [
              _createVNode(_component_Icon, {
                class: "me-2",
                name: "thumbs-up"
              }),
              _cache[1] || (_cache[1] = _createElementVNode("span", null, "Ok. Entendi", -1))
            ]),
            _createElementVNode("button", {
              class: "btn btn-outline-info mt-3 w-100",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendLink && _ctx.sendLink(...args)))
            }, [
              _createVNode(_component_Icon, { name: "share-nodes" }),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ms-2" }, "Compartilhar link", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("button", _hoisted_6, [
      _createVNode(_component_Icon, {
        class: "me-2",
        name: "download"
      }),
      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Baixar driver", -1))
    ])
  ], 64))
}